import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/AboutUs/components/Hero'

const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const Growth = lazy(() => import('src/pages/AboutUs/components/Growth'))
const Investors = lazy(() => import('src/pages/AboutUs/components/Investors'))
const Partners = lazy(() => import('src/pages/AboutUs/components/Partners'))

export const AboutUs = (): JSX.Element => {
	return (
		<>
			<PageMeta
				title="About Voltality - Our Mission in EV Charging"
				description="Learn about Voltality's mission to revolutionize the EV charging industry with our advanced eRoaming network and corporate fleet solutions."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<Growth />
				<Partners />
				<Investors />
				<CallToActionSection />
			</Suspense>
		</>
	)
}
